export default function getGoogleAnalyticsIds () {
  const rawIds = process.env.VUE_APP_GA_IDS
  if (!rawIds || rawIds === '[]') return []
  const ids = rawIds.replace(/\s/g, '').split(',')
  return ids
}
